import { message } from 'antd';
import nanoid from 'nanoid';
// eslint-disable-next-line
import moment from 'moment';
import {
  publish,
  fetchQuestionnaire,
  saveDraft,
  fetchPreview,
} from '../../../../services/dataReport/create';
import { queryOutboxDetail } from "../../../../services/dataReport/outbox";


// 设置加载属性
const setSpinProps = ({ put, spinning = false, tip = '' }) => {
  return put({
    type: 'save',
    payload: {
      spinProps: {
        spinning,
        tip,
      },
    },
  });
};

const initState = () => {
  return {
    activeKey: '1',
    type: 'create',
    id: null,
    publishModalVisible: false,
    previewModalVisible: false,
    questionListError: false, // 题目未填写校验时置为红色标错状态
    formData: {
      title: '', // 通知标题
      description: '', // 通知内容
      senderName: '', // 发送人署名
      senderType: 'dept',
      /**
       * 附件信息列表
       * format    string  附件格式
       * name    string  文件名
       * size    number  文件大小
       * url   string   url地址
       */
      chooseUserModuleId: '', // 选人组件模板id
      isCounty: 1, // 是否为区县，0=否，1=是
      questionList: [],
      endDate: null,
      // endDate: moment(new Date()).add(30, 'days'),
      isAnonymous: '',
      status: '0',
      selectUserType: 'user',
      allowProxy: '0',
      visibleScope: 0,
    },
    requiredFields: ['description', 'timer', 'title', 'chooseUserModuleId'], // 必填字段数组
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
    questionList: [], // 问卷收集列表
  };
};

export default {
  namespace: 'dataReportCreate',

  state: initState(),

  effects: {
    *fetchDetails({ payload }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const response = yield call(queryOutboxDetail, payload);

        const {
          endDate,
          createUserName,
          behalfOf,
          questionList,
          ...otherProps
        } = response;

        questionList.forEach(item=>{
          if(item.type === '9') {
            item.type = '0';
          }
          if(item.completionList) {
            item.completionList.forEach(subItem=>{
              if (subItem.type === 'input') {
                subItem.value = '';
              }
            })
          }
        });

        const { isCreate, type } = payload;

        // 转换时间
        let newTimer = endDate;
        if ((type === 'reEdit' || isCreate || endDate === null)) {
          newTimer = moment(new Date()).add(30, 'days')
        } else {
          newTimer = moment(new Date(endDate));
        }

        const { formData: initFormData } = initState();
        const formData = Object.assign({}, initFormData, {
          ...otherProps,
          timer: newTimer,
          endDate: newTimer,
          senderName: createUserName,
          senderType: behalfOf === 0 ? 'personal' : 'dept',
          questionList,
        });

        yield put({
          type: 'saveFormData', // 在saveFormData方法中修改btnStatus状态
          payload: {
            formData,
          },
        });

        yield put({
          type: 'save',
          payload: {
            spinProps: {
              spinning: false,
            },
            type: 'edit',
          },
        });
        return Promise.resolve(formData);

      } catch (error) {
        yield setSpinProps({ put });
        return Promise.reject();
      }
    },
    *fetchSaveDraft({ payload }, { call, put }) {
      try {
        const data = yield call(saveDraft, payload);

        return Promise.resolve(data);

      } catch (error) {
        return Promise.reject();
      }
    },
    *fetchPreview({ payload }, { call, put }) {
      try {
        const data = yield call(fetchPreview, payload);

        return Promise.resolve(data);

      } catch (error) {
        return Promise.reject();
      }
    },
    *fetchSubmit({ payload }, { call, put }) {
      try {

        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const response  = yield call(publish, payload);

        message.success('发布成功');

        yield put({
          type: 'reset',
        });
        return Promise.resolve(response);
      } catch (error) {
        yield setSpinProps({ put });
        return Promise.reject(error);
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    // 保存表单数据
    saveFormData(state, { payload }) {
      const { formData, requiredFields } = state;
      const { formData: newFormData = {}, ...otherProps } = payload;

      const data = Object.assign({}, { ...formData, ...newFormData, ...payload });
      let isHasNullKey = false;

      // 遍历查找有否有必填项未填
      for (let index = 0, len = requiredFields.length; index < len; index += 1) {
        const key = requiredFields[index];
        const element = data[key];

        if (
          (!element || (typeof element === 'string' && element.replace(/^\s+|\s+$/g, '').length === 0)) ||
          element.length === 0
        ) {
          isHasNullKey = true;
          break;
        }

      }

      // 判断按钮可点击状态
      data.btnStatus = isHasNullKey;

      return {
        ...state,
        ...otherProps,
        formData: data,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
